import { render } from "./OrderFilters.vue?vue&type=template&id=4f044242&scoped=true&ts=true"
import script from "./OrderFilters.vue?vue&type=script&lang=ts"
export * from "./OrderFilters.vue?vue&type=script&lang=ts"

import "./OrderFilters.vue?vue&type=style&index=0&id=4f044242&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f044242"]])

export default __exports__